# Explore

Field-by-field and record-by-record review, with a keyboard queue for working
through a list of cells without leaving the keyboard.

**Corroboration** is advisory. When several records agree on a value the
reference run also carried, that agreement is shown as support for restoring it
— it is evidence for your decision, never a decision in itself, and nothing here
backfills on its own.

Values you type by hand are recorded as your value, with your reason, and are
marked as manual in the audit. The provenance of every exported value says where
it came from.
